import React from "react";
import { clearTokens } from "../services/authSlice";
import { useDispatch } from "react-redux";

const Logout = () => {
  const dispatch = useDispatch();
  dispatch(clearTokens());
  window.location.href = "/login";
  return <></>;
};

export default Logout;